import api from "./api";

const programService = {};
const programEndpoint = "/programs";

programService.getAllPrograms = function (queryParams) {
  return api
    .get(programEndpoint, { params: queryParams })
    .then((res) => res.data);
};

programService.getProgramById = function (programId) {
  return api.get(`${programEndpoint}/${programId}`).then((res) => res.data);
};

programService.createProgram = function (program) {
  return api.post(programEndpoint, program).then(({ data }) => data);
};

programService.updateProgram = function (program) {
  return api
    .put(`${programEndpoint}/${program._id}`, program)
    .then(({ data }) => data);
};

programService.deleteProgram = function (programId) {
  return api.delete(`${programEndpoint}/${programId}`);
};

export default programService;
